import { registerSW } from "virtual:pwa-register";

/**
 * Registers the vite-plugin-pwa/workbox-generated service worker.
 *
 * Update contract (registerType: "autoUpdate", vite.config.ts —
 * documented in full in
 * docs/NORMAX_PERFORMANCE_PWA_AND_BRANDING_IMPLEMENTATION_REPORT.md §7):
 *
 * - When a new build is deployed, the browser detects the changed service
 *   worker on its normal update-check cadence and installs it in the
 *   background.
 * - "autoUpdate" means the new worker calls `skipWaiting()` +
 *   `clientsClaim()` itself as soon as it finishes installing — it becomes
 *   the ACTIVE worker for all network requests immediately, with no user
 *   prompt and no button to click.
 * - An already-open tab is NOT force-reloaded. It keeps running the JS
 *   already loaded in memory until its own next full navigation — this
 *   function deliberately does not add a `controllerchange` listener that
 *   calls `location.reload()`, which is the classic cause of an unwanted
 *   reload loop. A business app with in-progress form state (draft
 *   autosave notwithstanding) should never be yanked out from under a user
 *   without their own action.
 * - The NEXT launch (new tab, or a manual refresh of an existing one)
 *   is served entirely by the already-active new worker — the user always
 *   gets the latest version from that point on, automatically, no stale
 *   version ever "sticks" beyond the current tab's lifetime.
 */
export function registerServiceWorker(): void {
  registerSW({ immediate: true });
}
